<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="6.314" height="10.171" viewBox="0 0 6.314 10.171">
		<path
			id="Path_19225"
			data-name="Path 19225"
			d="M653.951,301.439c1.185-.11,1.253-.124,1.433-1.047l1.268-6.529a3.964,3.964,0,0,0,.11-.717c0-.413-.248-.427-1.2-.5a2.752,2.752,0,0,1,.082-.441c.524,0,1.419.028,2.094.028.62,0,1.432-.028,1.957-.028a1.248,1.248,0,0,1-.083.441c-1.185.11-1.227.11-1.4,1.047l-1.268,6.529a4.085,4.085,0,0,0-.124.717c0,.4.207.427,1.157.5a2.253,2.253,0,0,1-.083.44c-.537,0-1.295-.027-1.928-.027-.676,0-1.571.027-2.081.027A1.274,1.274,0,0,1,653.951,301.439Z"
			transform="translate(-653.632 -291.958)"
			fill="#515a70"
			stroke="#515a70"
			stroke-width="0.5"
		/>
	</svg>
</template>

<script>
export default {
	name: 'ItalicSvg',
};
</script>

<style scoped lang="scss"></style>
